import { NumberInput, TextInput } from '@core/components/Inputs';
import { Grid } from '@material-ui/core';
import NP from 'number-precision';
import React from 'react';

const getCurrency = (value) => {
  const numberValue = Number(value);
  if (isNaN(numberValue)) return ' - ';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(numberValue);
};

export const CalculoAproveitamentoCredito = ({ aproveitamentoCredito = {}, valorTotalCategorias = 0 }) => {
  const tipoAproveitamentoCredito = aproveitamentoCredito?.tipoAproveitamentoCredito;

  const aliquotaCbs = NP.divide(Number(aproveitamentoCredito.aliquotaCbs) || 0, 100);
  const aliquotaIbs = NP.divide(Number(aproveitamentoCredito.aliquotaIbs) || 0, 100);

  const valorBaseCbs = NP.times(valorTotalCategorias, aliquotaCbs);
  const valorBaseIbs = NP.times(valorTotalCategorias, aliquotaIbs);

  if (tipoAproveitamentoCredito === 'CREDITO_PARCIAL') {
    const percentual = NP.divide(Number(aproveitamentoCredito.percentualCredito) || 0, 100);

    const valorParcialCbs = NP.times(valorBaseCbs, percentual);
    const valorParcialIbs = NP.times(valorBaseIbs, percentual);

    return (
      <>
        <Grid item xs={12} sm={4}>
          <span>{`Valores base: IBS = ${getCurrency(valorBaseIbs)} | CBS = ${getCurrency(valorBaseCbs)}`}</span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            {`Valores parcial: IBS = ${getCurrency(valorParcialIbs)} | CBS = ${getCurrency(valorParcialCbs)}`}
          </span>
        </Grid>
      </>
    );
  }

  if (tipoAproveitamentoCredito === 'CREDITO_INTEGRAL') {
    const creditoTotal = NP.plus(valorBaseIbs, valorBaseCbs);
    return (
      <>
        <Grid item xs={12}>
          <span>
            <strong>{'Valores de crédito calculados: '}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{'Crédito IBS'}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{'Crédito CBS'}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{'Crédito total'}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{getCurrency(valorBaseIbs)}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{getCurrency(valorBaseCbs)}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={4}>
          <span>
            <strong>{getCurrency(creditoTotal)}</strong>
          </span>
        </Grid>
        <Grid item xs={12} sm={6}>
          <span>{`Valores base: IBS = ${getCurrency(valorBaseIbs)} | CBS = ${getCurrency(valorBaseCbs)}`}</span>
        </Grid>
      </>
    );
  }
  return null;
};

export const CamposAproveitamentoCredito = ({ formik, valorTotalCategorias, disabled = false }) => {
  const tipoAproveitamentoCredito = formik?.values?.aproveitamentoCredito?.tipoAproveitamentoCredito;
  const PARCIAL = tipoAproveitamentoCredito === 'CREDITO_PARCIAL';
  const inputSize = PARCIAL ? 2 : 4;

  return (
    <>
      {PARCIAL && (
        <Grid item xs={12} sm={4}>
          <NumberInput
            id="aproveitamentoCredito.percentualCredito"
            label="Percentual de crédito (%)"
            decimalScale={8}
            decimalSeparator=","
            allowNegative={false}
            isAllowed={(values) => {
              return !values.floatValue || values.floatValue <= 100;
            }}
            value={formik?.values.aproveitamentoCredito?.percentualCredito}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            touched={!!formik.errors?.aproveitamentoCredito?.percentualCredito}
            error={formik.errors?.aproveitamentoCredito?.percentualCredito}
            required
            disabled={disabled}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={inputSize}>
        <NumberInput
          id="aproveitamentoCredito.aliquotaIbs"
          label="Alíquota IBS (%)"
          decimalScale={8}
          decimalSeparator=","
          allowNegative={false}
          isAllowed={(values) => {
            return !values.floatValue || values.floatValue <= 100;
          }}
          value={formik?.values?.aproveitamentoCredito?.aliquotaIbs}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={!!formik?.errors?.aproveitamentoCredito?.aliquotaIbs}
          error={formik?.errors?.aproveitamentoCredito?.aliquotaIbs}
          required
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} sm={inputSize}>
        <NumberInput
          id="aproveitamentoCredito.aliquotaCbs"
          label="Alíquota CBS (%)"
          decimalScale={8}
          decimalSeparator=","
          allowNegative={false}
          isAllowed={(values) => {
            return !values.floatValue || values.floatValue <= 100;
          }}
          value={formik?.values.aproveitamentoCredito?.aliquotaCbs}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          touched={!!formik?.errors?.aproveitamentoCredito?.aliquotaCbs}
          error={formik?.errors?.aproveitamentoCredito?.aliquotaCbs}
          required
          disabled={disabled}
        />
      </Grid>
      <CalculoAproveitamentoCredito
        aproveitamentoCredito={formik?.values?.aproveitamentoCredito}
        valorTotalCategorias={valorTotalCategorias}
      />
      {PARCIAL && (
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextInput
            id="aproveitamentoCredito.observacaoJustificativa"
            name="aproveitamentoCredito.observacaoJustificativa"
            label="Observação (justificativa)"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik?.values?.aproveitamentoCredito?.observacaoJustificativa}
            error={formik?.errors?.aproveitamentoCredito?.observacaoJustificativa}
            touched={formik?.touched?.aproveitamentoCredito?.observacaoJustificativa}
            fullWidth
            multiline
            maxLength={500}
            rows={3}
            variant="outlined"
            required
            disabled={disabled}
          />
        </Grid>
      )}
    </>
  );
};
